import { render, staticRenderFns } from "./main-view.vue?vue&type=template&id=57cbe92e&scoped=true&"
import script from "./main-view.vue?vue&type=script&lang=js&"
export * from "./main-view.vue?vue&type=script&lang=js&"
import style0 from "./main-view.vue?vue&type=style&index=0&id=57cbe92e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cbe92e",
  null
  
)

export default component.exports